angular.module('bizmetryApp').factory('AuthService', ['$http', '$interval', '$window', 'CONFIG', 'ConfigurationService', 'dialogService',
  function ($http, $interval, $window, CONFIG, ConfigurationService, dialogService) {

    const service = {};
    service._monitorActive = false;

    // =====================================================
    // 🔐 LOGIN
    // =====================================================
    service.authenticate = function (username, password, twoFaCode) {
      let query = `?username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`;

      if (twoFaCode) {
        query += `&twoFaToken=${encodeURIComponent(twoFaCode)}`;
      }

      return $http.post(`${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-account/login${query}`, null, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        const data = response.data;

        if (data.access_token) {
          const now = Date.now();

          const user = {
            id: data.id,
            userId: data.userId,
            email: data.email,
            firstName: data.firstName,
            lastName: data.lastName,
            countryId: data.countryId,
            countryLabel: data.countryLabel,
            stateId: data.stateId,
            stateLabel: data.stateLabel,
            orgName: data.orgName,
            orgAddress: data.orgAddress,
            accountType: data.accountType,
            accountTypeId: data.accountTypeId,
            lastLogin: data.lastLogin,
            isSuperUser: data.isSuperUser || false,
            roles: data.roles || []
          };

          const tokenInfo = {
            access_token: data.access_token,
            refresh_token: data.refresh_token,
            expires_at: now + (data.expires_in * 1000),
            refresh_expires_at: now + (data.refresh_expires_in * 1000),
            user: user
          };

          sessionStorage.setItem("authTokenInfo", JSON.stringify(tokenInfo));
          sessionStorage.setItem("user", JSON.stringify(user));
          $http.defaults.headers.common['Authorization'] = 'Bearer ' + tokenInfo.access_token;

          console.log("✅ Login OK — TokenInfo stored:", tokenInfo);

          service.startTokenMonitor();
        }

        return data;
      }).catch(function (error) {
        console.error("🚨 Login error:", error);
        throw error;
      });
    };

    // =====================================================
    // 🔁 TOKEN AUTO-REFRESH
    // =====================================================
    service.startTokenMonitor = function () {
      if (service._monitorActive) {
        console.warn("⚠️ [TokenMonitor] Already running — skipping duplicate start");
        return;
      }
      service._monitorActive = true;

      Promise.all([
        ConfigurationService.getFromCacheAsync('frontend.token_refresh_interval'),
        ConfigurationService.getFromCacheAsync('frontend.token_refresh_threshold_ms')
      ]).then(function (values) {
        const refreshInterval = parseInt(values[0]) || 60000;
        const refreshThreshold = parseInt(values[1]) || 5 * 60 * 1000;

        console.log('🔁 [TokenMonitor] Starting —', {
          interval_ms: refreshInterval,
          threshold_ms: refreshThreshold
        });

        $interval(function () {
          console.log("⏱️ [TokenMonitor] Tick —", new Date().toLocaleTimeString());

          const tokenInfoRaw = sessionStorage.getItem("authTokenInfo");
          if (!tokenInfoRaw) {
            console.warn("⚠️ [TokenMonitor] No authTokenInfo in sessionStorage — skipping");
            return;
          }

          let tokenInfo;
          try {
            tokenInfo = JSON.parse(tokenInfoRaw);
          } catch (e) {
            console.warn("⚠️ [TokenMonitor] Malformed authTokenInfo — skipping");
            return;
          }

          if (!tokenInfo.refresh_token) {
            console.warn("⚠️ [TokenMonitor] No refresh_token present — session will expire naturally");
            return;
          }

          const now = Date.now();
          const accessExpiresInSec = tokenInfo.expires_at ? Math.round((tokenInfo.expires_at - now) / 1000) : null;
          const refreshExpiresInSec = tokenInfo.refresh_expires_at ? Math.round((tokenInfo.refresh_expires_at - now) / 1000) : null;
          const renewalTriggersAt = tokenInfo.refresh_expires_at ? new Date(tokenInfo.refresh_expires_at - refreshThreshold).toLocaleTimeString() : "N/A";
          const renewalTriggersInSec = tokenInfo.refresh_expires_at ? Math.round((tokenInfo.refresh_expires_at - refreshThreshold - now) / 1000) : null;

          console.log("🔍 [TokenMonitor] Status:", {
            now: new Date(now).toLocaleTimeString(),
            access_expires_at: tokenInfo.expires_at ? new Date(tokenInfo.expires_at).toLocaleTimeString() : "N/A",
            access_expires_in_sec: accessExpiresInSec !== null ? accessExpiresInSec : "N/A",
            refresh_expires_at: tokenInfo.refresh_expires_at ? new Date(tokenInfo.refresh_expires_at).toLocaleTimeString() : "N/A",
            refresh_expires_in_sec: refreshExpiresInSec !== null ? refreshExpiresInSec : "N/A",
            renewal_triggers_at: renewalTriggersAt,
            renewal_triggers_in_sec: renewalTriggersInSec !== null ? renewalTriggersInSec : "N/A",
            refresh_threshold_ms: refreshThreshold
          });

          // 🚨 1. Refresh token ya expiró → limpiar sesión
          if (tokenInfo.refresh_expires_at && now >= tokenInfo.refresh_expires_at) {
            console.error("🚨 [TokenMonitor] Refresh token EXPIRED — forcing session cleanup");
            sessionStorage.removeItem("authTokenInfo");
            sessionStorage.removeItem("user");
            delete $http.defaults.headers.common['Authorization'];
            service._monitorActive = false;
            return;
          }

          // 🔄 2. Refresh token próximo a vencer → intentar refresh
          if (tokenInfo.refresh_expires_at && now >= tokenInfo.refresh_expires_at - refreshThreshold) {
            console.log(`🔄 [TokenMonitor] Refresh token expiring in < ${refreshThreshold / 1000}s — triggering refresh...`);

            $http.post(`${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-account/refresh`, {
              refresh_token: tokenInfo.refresh_token
            }, {
              headers: { Authorization: 'Bearer ' + tokenInfo.access_token }
            }).then(function (response) {
              const data = response.data;
              const refreshedAt = Date.now();

              const updated = {
                access_token: data.access_token,
                refresh_token: data.refresh_token,
                expires_at: refreshedAt + (data.expires_in * 1000),
                refresh_expires_at: refreshedAt + (data.refresh_expires_in * 1000),
                user: tokenInfo.user
              };

              sessionStorage.setItem("authTokenInfo", JSON.stringify(updated));
              $http.defaults.headers.common['Authorization'] = 'Bearer ' + updated.access_token;

              console.log("✅ [TokenMonitor] Token refreshed successfully — new expiry:", {
                access_expires_at: new Date(updated.expires_at).toLocaleTimeString(),
                access_expires_in_sec: data.expires_in,
                refresh_expires_at: new Date(updated.refresh_expires_at).toLocaleTimeString(),
                refresh_expires_in_sec: data.refresh_expires_in,
                next_renewal_at: new Date(updated.refresh_expires_at - refreshThreshold).toLocaleTimeString()
              });
            }).catch(function (err) {
              console.error("❌ [TokenMonitor] Token refresh FAILED:", err?.status, err?.data || err);

              sessionStorage.removeItem("authTokenInfo");
              sessionStorage.removeItem("user");
              delete $http.defaults.headers.common['Authorization'];
              service._monitorActive = false;

              dialogService.showInformationDialog(
                'Session Timed Out',
                'Your session has been timed out. Please log in once again.'
              ).then(function () {
                $window.location.href = '/login';
              });
            });

          } else {
            console.log("✅ [TokenMonitor] Tokens OK — no action needed");
          }

        }, refreshInterval);
      });
    };

    // =====================================================
    // 🚪 LOGOUT
    // =====================================================
    service.logout = function () {
      const tokenInfoRaw = sessionStorage.getItem("authTokenInfo");
      if (!tokenInfoRaw) return Promise.reject("No active session");

      const tokenInfo = JSON.parse(tokenInfoRaw);

      return $http.post(`${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-account/logout`, {}, {
        headers: { Authorization: 'Bearer ' + tokenInfo.access_token }
      }).then(function (response) {
        sessionStorage.removeItem("authTokenInfo");
        sessionStorage.removeItem("user");
        delete $http.defaults.headers.common['Authorization'];
        service._monitorActive = false;
        console.log("✅ Logged out.");
        return response.data;
      }).catch(function (error) {
        console.error("❌ Logout error:", error);
        return Promise.reject("Logout failed");
      });
    };

    // =====================================================
    // 🧨 DELETE ACCOUNT
    // =====================================================
    service.deleteAccount = function (accountId) {
      const tokenInfoRaw = sessionStorage.getItem("authTokenInfo");
      if (!tokenInfoRaw) return Promise.reject("No active session");

      const tokenInfo = JSON.parse(tokenInfoRaw);

      return $http.delete(`${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-account/account/${accountId}`, {
        headers: { Authorization: 'Bearer ' + tokenInfo.access_token }
      }).then(function (response) {
        sessionStorage.removeItem("authTokenInfo");
        sessionStorage.removeItem("user");
        delete $http.defaults.headers.common['Authorization'];
        service._monitorActive = false;
        console.log("🧨 Account deleted.");
        return response.data;
      }).catch(function (error) {
        console.error("❌ Account deletion failed:", error);
        return Promise.reject("Account deletion failed");
      });
    };

    // =====================================================
    // 🏢 LOAD ORGANIZATIONS (login page bubble diagram)
    // =====================================================
    service.loadOrganizations = function () {
      return $http.post(CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-account/temp-auth')
        .then(function (res) {
          const tempToken = res.data.access_token;
          return $http.get(CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-account/account', {
            headers: { Authorization: 'Bearer ' + tempToken }
          });
        })
        .then(function (res) {
          const accounts = res.data || [];
          const seen = new Set();
          return accounts
            .filter(a => a.isActive && a.organization)
            .reduce((acc, a) => {
              const key = a.organization.trim().toLowerCase();
              if (!seen.has(key)) { seen.add(key); acc.push({ name: a.organization.trim() }); }
              return acc;
            }, [])
            .slice(0, 20);
        });
    };

    // =====================================================
    // 🔑 ACCOUNT RECOVERY
    // =====================================================
    service.recover = function (email) {
      return $http.post(`${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-account/temp-auth`)
        .then(function (res) {
          var tempToken = res.data.access_token;
          return $http.post(
            `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-account/recover`,
            { email: email },
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + tempToken
              }
            }
          );
        })
        .then(function (response) {
          console.log('✅ Recovery request submitted for:', email);
          return response.data;
        })
        .catch(function (error) {
          console.error('❌ Recovery request failed:', error);
          throw error;
        });
    };

    // =====================================================
    // 🔑 RESET PASSWORD
    // =====================================================
    service.resetPassword = function (token, newPassword) {
      return $http.post(`${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-account/temp-auth`)
        .then(function (res) {
          var tempToken = res.data.access_token;
          return $http.post(
            `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-account/reset-password`,
            { token: token, newPassword: newPassword },
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + tempToken
              }
            }
          );
        })
        .then(function (response) {
          console.log('✅ Password reset successful');
          return response.data;
        })
        .catch(function (error) {
          console.error('❌ Password reset failed:', error);
          throw error;
        });
    };

    return service;
  }

]);